<template>
  <!-- <svg
        width="500"
        height="500"
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g>
            <path
                d="M413.389 137.297C397.237 65.4968 325.937 20.3855 254.137 36.5381C217.79 44.7154 186.526 67.7347 167.926 100.016H166.684C114.395 100.146 69.6288 137.528 60.1752 188.955C12.6302 206.369 -11.7966 259.029 5.61759 306.575C18.8457 342.69 53.2095 366.71 91.6718 366.725H100.006V350.055H91.6718C50.2434 350.037 16.6756 316.437 16.6943 275.009C16.71 241.954 38.3603 212.806 70.0017 203.241C73.1335 202.285 75.4151 199.586 75.836 196.339C81.9213 150.797 120.736 116.764 166.684 116.685C167.951 116.685 169.184 116.777 170.451 116.86L172.218 116.969C175.473 117.127 178.528 115.399 180.069 112.526C209.933 55.4776 280.39 33.4397 337.439 63.3048C369.249 79.9564 391.612 110.336 398.062 145.656C398.661 148.979 401.205 151.612 404.505 152.324C458.472 164.102 492.672 217.399 480.894 271.366C470.884 317.228 430.326 349.959 383.385 350.055V366.725C447.828 366.686 500.039 314.413 500 249.97C499.969 197.134 464.439 150.913 413.389 137.297Z"
                fill="#BEC9CF"
            />
            <path
                d="M241.696 216.701C172.649 216.701 116.676 272.674 116.676 341.721C116.676 410.767 172.649 466.741 241.696 466.741C310.742 466.741 366.715 410.767 366.715 341.721C366.637 272.706 310.71 216.778 241.696 216.701ZM241.696 450.071C181.855 450.071 133.345 401.561 133.345 341.721C133.345 281.88 181.855 233.37 241.696 233.37C301.536 233.37 350.046 281.88 350.046 341.721C349.977 401.532 301.507 450.001 241.696 450.071Z"
                fill="#277FAF"
            />
            <path
                d="M294.738 300.464L282.953 288.679L241.696 329.936L200.44 288.679L188.654 300.464L229.911 341.721L188.654 382.977L200.44 394.762L241.696 353.506L282.953 394.762L294.738 382.977L253.481 341.721L294.738 300.464Z"
                fill="#277FAF"
            />
        </g>
    </svg> -->
  <svg
    width="317"
    height="300"
    viewBox="0 0 317 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M246.83 285.758C246.83 285.758 247.67 290.499 248.082 295.206C248.119 295.642 248.067 296.08 247.93 296.496C247.792 296.911 247.572 297.294 247.283 297.621C246.993 297.949 246.64 298.215 246.245 298.403C245.85 298.591 245.421 298.696 244.983 298.714C238.717 298.977 225.315 299.483 220.508 299.268C220.338 299.261 220.173 299.212 220.026 299.127C219.879 299.042 219.755 298.923 219.664 298.78C219.572 298.637 219.517 298.475 219.502 298.306C219.487 298.137 219.513 297.967 219.577 297.81C219.803 297.247 220.235 296.792 220.785 296.537L242.921 286.375L246.83 285.758Z"
      fill="#16558F"
    />
    <path
      d="M247.52 282.969L246.845 288.646C246.845 288.646 242.969 290.451 240.319 288.42L241.928 282.09L247.52 282.969Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M247.013 176.188C247.305 177.672 248.575 250.21 240.808 282.706C240.743 282.963 240.773 283.234 240.892 283.47C241.011 283.706 241.212 283.891 241.458 283.99C243.473 284.772 245.607 285.206 247.768 285.273C248.19 285.288 248.604 285.162 248.946 284.915C249.287 284.668 249.537 284.314 249.655 283.91C251.874 276.369 262.502 238.585 263.889 202.489C265.44 162.16 263.889 201.118 263.889 201.118L262.98 176.188H247.013Z"
      fill="#343434"
    />
    <path
      d="M272.298 288.234C272.298 288.234 273.634 290.63 274.926 296.986C274.983 297.257 274.982 297.537 274.923 297.808C274.864 298.079 274.749 298.334 274.584 298.557C274.42 298.78 274.211 298.967 273.97 299.104C273.729 299.241 273.461 299.325 273.185 299.352C271.119 299.556 267.933 299.819 265.382 299.801C265.105 299.8 264.832 299.741 264.579 299.627C264.327 299.514 264.101 299.349 263.917 299.142C263.733 298.936 263.594 298.693 263.51 298.429C263.426 298.166 263.399 297.888 263.429 297.613C263.714 295.287 264.594 291.472 267.313 288.497L272.298 288.234Z"
      fill="#16558F"
    />
    <path
      d="M273.47 280.931L271.893 289.518C271.893 289.518 270.335 290.677 267.254 289.835L268.006 280.595L273.47 280.931Z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M277.729 178.401C284.076 216.688 276.35 272.985 273.747 284.005C273.67 284.335 273.497 284.635 273.25 284.867C273.002 285.099 272.692 285.253 272.357 285.31C270.708 285.605 269.014 285.538 267.393 285.113C267.075 285.02 266.793 284.829 266.59 284.567C266.386 284.305 266.27 283.986 266.258 283.654C265.893 274.743 266.539 220.039 260.626 198.42C260.327 197.324 259.656 196.366 258.728 195.71L247.25 187.557L246.37 174.39L277.729 178.401Z"
      fill="#313131"
    />
    <path
      d="M221.22 123.865C222.187 130.721 223.205 132.296 223.997 132.336C226.515 132.467 226.008 117.021 235.22 109.192C241.038 104.255 248.987 103.847 255.221 104.423L246.494 135.698C245.221 138.812 239.684 151.41 227.15 155.232C224.596 156.012 220.8 157.172 217.267 155.655C210.296 152.661 207.025 140.391 210.142 125.025C211.61 124.482 213.639 123.905 221.22 123.865Z"
      fill="#16558F"
    />
    <path
      d="M223.442 97.1298L222.289 103.65C220.435 111.617 220.26 118.261 221.22 123.869C219.628 123.935 217.957 124.048 216.216 124.234C214.07 124.445 212.04 124.722 210.142 125.047C211.146 116.941 216.544 103.482 216.544 103.482C219.8 98.7707 220.187 101.826 223.442 97.1298Z"
      fill="url(#paint2_linear)"
    />
    <path
      d="M210.256 83.4011C210.901 83.3848 211.542 83.5136 212.131 83.7781C212.719 84.0425 213.241 84.4359 213.657 84.9289L221.884 94.6685C221.884 94.6685 223.38 94.3622 223.523 91.4961C223.665 88.6301 226.709 88.2873 226.709 88.2873C226.709 88.2873 226.267 92.2983 225.431 98.1946C224.953 101.578 222.953 104.029 221.329 105.542L216.584 103.905C212.205 97.6695 209.507 90.796 208 83.4631L210.256 83.4011Z"
      fill="url(#paint3_linear)"
    />
    <path
      d="M287.799 109.9C287.248 109.757 283.503 105.888 282.938 105.783C273.704 104.022 250.648 97.819 235.22 109.192C235.18 109.52 235.154 109.783 235.14 109.998C234.902 110.347 234.689 110.712 234.505 111.092C233.026 113.956 231.283 116.676 229.297 119.216C229.742 119.655 230.105 120.17 230.37 120.737C234.078 128.671 248.133 160.358 245.662 179.739C245.629 179.976 245.642 180.218 245.702 180.45C245.762 180.682 245.868 180.9 246.012 181.091C246.157 181.283 246.337 181.444 246.544 181.565C246.751 181.687 246.979 181.766 247.217 181.799C252.673 182.554 268.919 184.392 277.313 180.928C277.551 180.829 277.755 180.662 277.897 180.446C278.038 180.231 278.112 179.979 278.109 179.721C278.054 175.83 278.218 158.958 284.408 138.619C284.64 137.86 284.83 137.09 284.978 136.31C285.054 136.467 285.127 136.624 285.2 136.781L287.799 109.9Z"
      fill="#16558F"
    />
    <path
      d="M273.704 104.014C290.927 105.272 294.526 115.107 306.428 109.094L304.322 127.512C299.909 132.38 293.245 135.698 284.846 136.941L273.704 104.014Z"
      fill="#16558F"
    />
    <path
      d="M261.933 87.3684C264.886 93.2464 266.116 99.2338 266.488 104.806C265.853 105.043 257.363 110.913 251.71 105.229C252.922 101.331 252.721 95.4598 252.414 89.4359L261.933 87.3684Z"
      fill="url(#paint4_linear)"
    />
    <path
      d="M246.567 71.9259C246.403 72.1884 242.188 92.1343 242.188 92.1343L253.641 94.3221L260.462 76.0135C260.462 76.0135 249.283 67.5247 246.567 71.9259Z"
      fill="url(#paint5_linear)"
    />
    <path
      d="M256.075 77.6143C256.226 77.8217 256.328 78.0609 256.373 78.3136C256.418 78.5664 256.405 78.826 256.334 79.0728L253.538 88.8488C253.497 88.9968 253.434 89.138 253.352 89.2682C252.9 89.9975 251.279 92.1853 249.093 90.3621C247.228 88.8342 245.494 87.445 243.939 87.1168C243.723 87.0709 243.5 87.0683 243.283 87.109C243.066 87.1497 242.859 87.2329 242.674 87.3539C242.489 87.4749 242.33 87.6313 242.206 87.814C242.081 87.9968 241.995 88.2022 241.95 88.4186C241.306 91.4221 240.885 94.469 240.691 97.5346C240.673 97.9523 240.814 98.3614 241.084 98.6803C241.355 98.9993 241.736 99.2047 242.151 99.2557C244.425 99.5365 248.885 99.9521 252.619 99.4854C252.919 99.4474 253.204 99.3287 253.443 99.1418C253.681 98.955 253.864 98.707 253.973 98.4243C254.955 95.8718 257.728 88.7978 258.82 86.9126C259.834 85.166 262.532 85.0019 263.769 85.0238C264.001 85.0277 264.232 84.9837 264.447 84.8947C264.662 84.8056 264.856 84.6733 265.017 84.506C265.995 83.4923 267.572 81.195 264.904 78.7301C264.588 78.4298 264.402 78.0181 264.386 77.5828C264.369 77.1475 264.524 76.7231 264.816 76.4C265.889 75.193 266.871 73.2057 264.816 70.9632C262.761 68.7207 260.243 69.1072 258.637 69.7562C258.29 69.9007 257.905 69.9295 257.54 69.8382C257.175 69.7469 256.85 69.5404 256.612 69.2494C256.497 69.0949 256.343 68.9735 256.166 68.8973C255.989 68.8211 255.795 68.7929 255.604 68.8155C255.389 68.8344 255.172 68.8104 254.967 68.7449C254.761 68.6794 254.571 68.5736 254.406 68.4338C254.242 68.294 254.107 68.1229 254.009 67.9305C253.912 67.7381 253.853 67.5283 253.838 67.3132C253.728 65.7416 252.987 63.8636 250.254 63.1927C245.232 61.9602 242.454 66.9047 242.366 70.4855C242.279 74.0663 247.797 75.0764 250.976 74.6424C253.33 74.3288 255.228 76.462 256.075 77.6143Z"
      fill="#343434"
    />
    <path
      d="M257.112 90.6428C257.112 90.6428 258.177 84.3309 260.725 83.8714C263.272 83.412 265.893 85.3665 263.557 88.9764C260.648 93.4724 257.112 90.6428 257.112 90.6428Z"
      fill="url(#paint6_linear)"
    />
    <path
      d="M261.313 67.9148C260.822 67.8983 260.332 67.9436 259.853 68.0497C258.645 68.305 257.031 68.9285 257.451 70.0917C258.082 71.8383 261.353 70.2047 263.097 73.0088C264.63 75.492 263.375 78.1867 263.845 80.8595C264.072 82.1613 264.911 84.0939 266.072 84.8524C266.594 85.1915 270.7 85.8442 270.926 85.1149L272.068 81.4102C273.094 78.081 269.149 72.5348 267.112 70.2886C265.543 68.5821 263.411 68.0133 261.313 67.9148Z"
      fill="url(#paint7_linear)"
    />
    <path
      d="M265.207 81.2935L269.134 84.5753C276.671 87.7768 282.146 91.5509 286.113 95.6312C287.867 92.2952 290.435 89.4556 293.58 87.3757C285.985 83.6382 280.332 82.0848 280.332 82.0848C265.002 75.9114 265.207 81.2935 265.207 81.2935Z"
      fill="url(#paint8_linear)"
    />
    <path
      d="M286.113 95.6276C298.5 108.39 294.872 101.896 294.978 112.766C295.015 116.813 298.533 132.281 298.533 132.281C336.422 115.931 304.803 93.6293 293.58 87.3757C290.436 89.4546 287.867 92.2929 286.113 95.6276Z"
      fill="#16558F"
    />
    <g>
      <path
        d="M51.9917 139.651L0.00567627 174.352L51.2117 250.738L103.198 216.037L51.9917 139.651Z"
        fill="#ffffff"
      />
      <path
        d="M76.3337 212.424L75.7407 216.067L49.8961 212.35L50.4892 208.706L76.3337 212.424Z"
        fill="#E0E0E0"
      />
      <path
        d="M63.3188 199.422L67.0254 199.959L62.911 225.351L59.2044 224.814L63.3188 199.422Z"
        fill="#E0E0E0"
      />
      <path
        d="M39.536 167.155C39.5731 167.206 34.3652 170.752 27.9018 175.061C21.4383 179.37 16.1702 182.829 16.1332 182.773C16.0961 182.718 21.3039 179.176 27.7674 174.863C34.2309 170.549 39.4758 167.1 39.536 167.155Z"
        fill="#E0E0E0"
      />
      <path
        d="M58.6345 162.365C58.6715 162.421 50.0073 168.265 39.2858 175.422C28.5643 182.579 19.8259 188.335 19.7981 188.284C19.7703 188.234 28.4161 182.38 39.1514 175.223C49.8868 168.066 58.5974 162.31 58.6345 162.365Z"
        fill="#E0E0E0"
      />
      <path
        d="M62.4662 168.08C62.5033 168.135 53.839 173.984 43.1175 181.141C32.3961 188.298 23.6577 194.055 23.6299 193.999C23.6021 193.944 32.2571 188.1 42.9832 180.938C53.7093 173.776 62.4292 168.025 62.4662 168.08Z"
        fill="#E0E0E0"
      />
      <path
        d="M66.298 173.799C66.3351 173.855 57.6708 179.703 46.9493 186.856C36.2278 194.008 27.4894 199.774 27.4894 199.718C27.4894 199.663 36.112 193.814 46.8381 186.657C57.5642 179.5 66.2609 173.744 66.298 173.799Z"
        fill="#E0E0E0"
      />
      <path
        d="M70.1158 179.518C70.1529 179.574 61.4886 185.418 50.7671 192.575C40.0457 199.732 31.3072 205.488 31.2841 205.433C31.2609 205.377 39.9206 199.533 50.6559 192.376C61.3913 185.219 70.1158 179.463 70.1158 179.518Z"
        fill="#E0E0E0"
      />
      <path
        d="M156.75 142.461L109.112 117.036L71.5939 187.033L119.232 212.458L156.75 142.461Z"
        fill="#ffffff"
      />
      <path
        d="M111.084 190.559L108.058 191.59L100.39 170.429L103.411 169.393L111.084 190.559Z"
        fill="#E0E0E0"
      />
      <path
        d="M115.717 175.376L116.82 178.413L95.7565 185.607L94.6538 182.574L115.717 175.376Z"
        fill="#E0E0E0"
      />
      <path
        d="M130.682 144.154C130.645 144.223 125.817 141.717 119.891 138.559C113.965 135.401 109.198 132.78 109.235 132.71C109.272 132.641 114.104 135.147 120.03 138.305C125.956 141.463 130.719 144.08 130.682 144.154Z"
        fill="#E0E0E0"
      />
      <path
        d="M142.117 156.743C142.08 156.813 134.083 152.614 124.256 147.371C114.429 142.128 106.497 137.819 106.534 137.75C106.571 137.681 114.563 141.874 124.39 147.122C134.218 152.369 142.155 156.674 142.117 156.743Z"
        fill="#E0E0E0"
      />
      <path
        d="M139.31 161.982C139.273 162.051 131.275 157.857 121.448 152.614C111.621 147.371 103.689 143.058 103.726 142.988C103.763 142.919 111.755 147.117 121.583 152.36C131.41 157.603 139.347 161.912 139.31 161.982Z"
        fill="#E0E0E0"
      />
      <path
        d="M136.502 167.22C136.465 167.289 128.468 163.096 118.64 157.853C108.813 152.61 100.881 148.315 100.918 148.231C100.955 148.148 108.948 152.356 118.775 157.599C128.602 162.842 136.539 167.151 136.502 167.22Z"
        fill="#E0E0E0"
      />
      <path
        d="M133.694 172.458C133.657 172.528 125.66 168.334 115.833 163.091C106.005 157.848 98.0686 153.539 98.1103 153.47C98.152 153.4 106.14 157.594 115.967 162.837C125.794 168.08 133.731 172.389 133.694 172.458Z"
        fill="#E0E0E0"
      />
      <path
        d="M88.6491 191.563L72.2472 275.617L70.1158 286.621L179.462 286.094C184.373 286.071 188.729 281.72 190.299 275.256L209.694 195.904C210.894 190.998 208.263 185.894 204.537 185.899L93.8384 186.014C91.4291 186.01 89.2699 188.285 88.6491 191.563Z"
        fill="#1C5BA3"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M88.6491 191.563L72.2472 275.617L70.1158 286.621L179.462 286.094C184.373 286.071 188.729 281.72 190.299 275.256L209.694 195.904C210.894 190.998 208.263 185.894 204.537 185.899L93.8384 186.014C91.4291 186.01 89.2699 188.285 88.6491 191.563Z"
          fill="#277FAF"
        />
      </g>
      <path
        d="M168.986 269.912L157.403 176.791C156.939 172.976 153.886 170.128 150.286 170.142L124.895 170.221C123.952 170.231 123.02 170.433 122.158 170.815C121.295 171.197 120.519 171.749 119.878 172.44L107.831 185.233L37.2194 185.612C32.9058 185.635 29.5883 189.713 30.1582 194.29L40.9121 280.356C41.3755 284.166 44.4288 287.009 48.0196 287.005L171.103 286.76C184.809 287.042 186.12 283.005 186.12 283.005C170.385 286.478 168.986 269.935 168.986 269.912Z"
        fill="#277FAF"
      />
      <g opacity="0.5">
        <path
          d="M115.911 251.284L111.76 255.736L79.7902 227.034L83.9416 222.586L115.911 251.284Z"
          fill="white"
        />
        <path
          d="M110.018 221.601L114.609 225.716L85.6791 256.721L81.0921 252.602L110.018 221.601Z"
          fill="white"
        />
      </g>
    </g>
    <path
      d="M194.237 33.9211C194.001 33.8216 193.798 33.657 193.651 33.4465C193.505 33.2359 193.422 32.9882 193.412 32.7323L193.12 25.9637C193.109 25.7534 193.148 25.5436 193.233 25.3509C193.318 25.1582 193.447 24.9878 193.609 24.8534C193.771 24.7189 193.963 24.624 194.168 24.5762C194.374 24.5284 194.587 24.529 194.792 24.5779C195.358 24.6998 195.943 24.7051 196.51 24.5934C197.078 24.4818 197.617 24.2557 198.094 23.9288C198.533 23.6511 198.911 23.2866 199.204 22.8576C199.496 22.4285 199.698 21.9442 199.796 21.4344C199.862 20.9182 199.824 20.3939 199.683 19.8928C199.543 19.3916 199.303 18.9238 198.978 18.5169C198.636 18.054 198.205 17.663 197.711 17.3664C197.217 17.0698 196.67 16.8733 196.1 16.7883C194.95 16.7245 193.813 17.0498 192.872 17.7117C191.931 18.3735 191.241 19.3331 190.914 20.4351C190.804 20.7691 190.57 21.0481 190.26 21.2141C189.95 21.3801 189.588 21.4202 189.249 21.3262C188.91 21.2322 188.621 21.0113 188.441 20.7094C188.261 20.4076 188.205 20.048 188.284 19.7058C188.781 17.9724 189.86 16.4627 191.341 15.4306C192.822 14.3985 194.613 13.907 196.414 14.0386C197.351 14.1633 198.254 14.4748 199.068 14.9547C199.883 15.4346 200.592 16.073 201.155 16.8321C201.702 17.5356 202.102 18.3415 202.332 19.2022C202.561 20.0629 202.616 20.9608 202.492 21.8428C202.325 22.7236 201.981 23.561 201.478 24.3036C200.976 25.0462 200.326 25.6782 199.57 26.1607C198.474 26.8974 197.194 27.3141 195.873 27.3641L196.1 32.5864C196.108 32.8158 196.059 33.0437 195.955 33.2489C195.852 33.454 195.699 33.6299 195.509 33.7601C195.32 33.8903 195.101 33.9706 194.872 33.9937C194.643 34.0167 194.412 33.9817 194.201 33.8919L194.237 33.9211Z"
      fill="#1C5BA3"
    />
    <path
      d="M196.239 36.6927C196.254 36.913 196.204 37.1328 196.094 37.3245C195.984 37.5161 195.82 37.671 195.622 37.7694C195.424 37.8678 195.201 37.9053 194.982 37.8773C194.762 37.8492 194.556 37.7568 194.39 37.6118C194.223 37.4668 194.103 37.2756 194.045 37.0625C193.987 36.8494 193.994 36.6239 194.064 36.4147C194.135 36.2054 194.266 36.0217 194.441 35.8868C194.616 35.7519 194.827 35.672 195.048 35.657C195.194 35.6461 195.342 35.6643 195.481 35.7106C195.62 35.7569 195.749 35.8303 195.86 35.9266C195.971 36.023 196.061 36.1403 196.126 36.2718C196.191 36.4033 196.229 36.5463 196.239 36.6927Z"
      fill="#1C5BA3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M171.165 25.2369C171.165 11.9278 181.954 1.13867 195.263 1.13867C208.572 1.13867 219.361 11.9278 219.361 25.2369C219.361 28.6194 218.665 31.8379 217.408 34.7578C217.386 34.8082 217.364 34.8585 217.342 34.9087L218 36.5L217.997 36.5074L222.231 46.236L213.667 42.6633L212.361 42.219C212.306 42.2738 212.252 42.3282 212.197 42.3825C207.844 46.6819 201.864 49.3352 195.263 49.3352C181.954 49.3352 171.165 38.546 171.165 25.2369ZM195.263 0.138672C181.402 0.138672 170.165 11.3755 170.165 25.2369C170.165 39.0983 181.402 50.3352 195.263 50.3352C202.018 50.3352 208.15 47.6664 212.661 43.3268L222.993 47.6374L224.14 48.1158L223.644 46.9764L218.411 34.9533C219.667 31.9641 220.361 28.6809 220.361 25.2369C220.361 11.3755 209.124 0.138672 195.263 0.138672Z"
      fill="black"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="247.52"
        y1="285.736"
        x2="240.319"
        y2="285.736"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="-16531.1"
        y1="8828.28"
        x2="-16637"
        y2="8828.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="-21281.6"
        y1="157603"
        x2="-22778.7"
        y2="164053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="10692.2"
        y1="209452"
        x2="7108.47"
        y2="215939"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="85817.5"
        y1="-2885.7"
        x2="87629.8"
        y2="-59.7823"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="-67240.3"
        y1="7376.54"
        x2="-70197.6"
        y2="7448.84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="-25299.8"
        y1="1118.47"
        x2="-26447.8"
        y2="1232.59"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="-51953.6"
        y1="23390.1"
        x2="-49930.8"
        y2="24551.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="-100963"
        y1="22497.8"
        x2="-98715.5"
        y2="25122.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="210" height="177" fill="white" transform="translate(0 110)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'PlugIcon',
}
</script>

<style scoped></style>
